<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="profile">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Profile
    </h1>
    <div class="mr-3 ml-3 my-3">
      <v-card flat class="rounded-card">
        <v-container fluid grid-list-md>
          <v-alert
            v-if="error"
            :value="true"
            type="error"
            icon="warning"
            class="mb-4"
          >
            {{ errorMessage }}
          </v-alert>
          <v-form
            id="profileForm"
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent
          >
            <v-layout row wrap>
              <v-flex d-flex xs12 sm4 md3 xl2>
                <v-card flat>
                  <v-card-title primary class="title"
                    ><span class="primary--text text-lighten-2"
                      >Update your profile</span
                    >
                  </v-card-title>
                  <v-card-text class="text-xs-center pa-3 ma-1 mt-4">
                    <a href="https://gravatar.com" target="_blank">
                      <v-responsive>
                        <v-avatar size="150" class="ma-2">
                          <img :src="avatarSource" />
                        </v-avatar>
                      </v-responsive>
                    </a>
                    <span class="hidden-xs-only">
                      <p class="mt-3 pa-2 body-1 grey--text font-weight-thin">
                        To manage your avatar please see the excellent
                        <a href="https://gravatar.com" target="_blank"
                          >gravatar.com</a
                        >
                        service.
                      </p>
                    </span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm8 md9 xl10>
                <v-card flat>
                  <v-card-title primary class="title hidden-xs-only"
                    ><span class="primary--text text-lighten-2"> </span>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <v-chip
                        v-if="isVerified && email && email === originalEmail"
                        slot="activator"
                        color="success"
                        text-color="white"
                        small
                      >
                        <v-avatar>
                          <v-icon>check_circle</v-icon>
                        </v-avatar>
                        Verified
                      </v-chip>
                      <span>This email address is verified</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        v-if="!isVerified && email && email === originalEmail"
                        slot="activator"
                        color="warning"
                        text-color="white"
                        round
                        small
                        class="text-lowercase"
                        @click="verifyEmail"
                      >
                        Not verified
                        <v-icon right>close</v-icon>
                      </v-btn>
                      <span>Click to begin verifying this email address</span>
                    </v-tooltip>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="firstname"
                      prepend-icon="person_outline"
                      name="firstname"
                      label="First name"
                      type="text"
                      :rules="[v => !!v || 'First name is required']"
                      required
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-text-field
                      v-model="lastname"
                      prepend-icon="blank"
                      name="lastname"
                      label="Last name"
                      type="text"
                      :rules="[v => !!v || 'Last name is required']"
                      required
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-text-field
                      v-model="nickname"
                      prepend-icon="blank"
                      name="nickname"
                      label="Display name (nickname)"
                      type="text"
                      class="my-1 mr-5"
                    ></v-text-field>
                    <v-text-field
                      v-model="email"
                      label="Email Address"
                      prepend-icon="blank"
                      name="email"
                      required
                      class="my-1 mr-5"
                      :rules="emailRules"
                      :error-messages="emailError"
                      type="email"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="mobile"
                      label="Mobile phone"
                      prepend-icon="blank"
                      name="mobile"
                      class="my-1 mr-5"
                      type="phone"
                    >
                    </v-text-field>
                    <v-textarea
                      v-model="description"
                      prepend-icon="blank"
                      rows="3"
                      name="description"
                      label="About you"
                      class="my-1 mr-5"
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12>
                <v-card color="grey lighten-5" flat class="rounded-card">
                  <v-alert
                    v-if="error"
                    :value="true"
                    type="error"
                    icon="warning"
                    class="mb-4"
                  >
                    {{ errorMessage }}
                  </v-alert>
                  <v-card-actions>
                    <Password :email="originalEmail">Password</Password>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      round
                      outline
                      color="primary"
                      :disabled="!isDirty"
                      @click="resetForm"
                    >
                      <span class="">Reset</span>
                    </v-btn>
                    <v-btn
                      :disabled="!valid || !isDirty"
                      type="submit"
                      round
                      color="accent"
                      :loading="loading"
                      form="profileForm"
                      @click="validate"
                    >
                      <v-icon small left>save</v-icon>
                      <span class="">Save</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
// import moment from 'moment-timezone'
// when time comes look to https://github.com/prantlf/timezone-support
import Password from './../components/Password';

export default {
  components: { Password },
  data: () => ({
    showPassword: false,
    loading: false,
    valid: true,
    error: false,
    errorMessage: 'Error.',
    emailError: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Minimum 7 characters'
    ],
    email: null,
    conflictEmail: null,
    password: '',
    // avatar: null,
    firstname: null,
    lastname: null,
    nickname: null,
    description: null,
    mobile: null,
    originalEmail: null,
    originalFirstname: null,
    originalLastname: null,
    originalNickname: null,
    originalDescription: null,
    originalMobile: null
  }),
  computed: {
    ...mapState('auth', ['user', 'isVerified']),
    ...mapGetters('auth', ['avatarSource']),
    isDirty() {
      return (
        this.firstname !== this.originalFirstname ||
        this.lastname !== this.originalLastname ||
        this.nickname !== this.originalNickname ||
        this.email !== this.originalEmail ||
        this.mobile !== this.originalMobile ||
        this.description !== this.originalDescription
      );
    }
  },
  watch: {
    email: function() {
      if (this.email !== this.conflictEmail) {
        this.emailError = null;
      }
    }
    // isVerified: function(newValue, oldValue) {
    //   // eslint-disable-next-line
    //   // console.log(`Updating isVerified from ${oldValue} to ${newValue}`);
    // }
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('beforeRouteEnter', to, from);
  //   next();
  // },
  created: async function() {
    // console.log('created');
    const res = await this.$store.dispatch('auth/getUser');
    if (res) {
      // console.log('res', res);
      this.firstname = res.firstname;
      this.originalFirstname = res.firstname;
      this.lastname = res.lastname;
      this.originalLastname = res.lastname;
      this.email = res.email;
      this.originalEmail = res.email;
      this.description = res.description;
      this.originalDescription = res.description;
      this.nickname = res.nickname;
      this.originalNickname = res.nickname;
      this.mobile = res.mobile;
      this.originalMobile = res.mobile;
    } else {
      this.firstname = this.user.firstname;
      this.originalFirstname = this.user.firstname;
      this.lastname = this.user.lastname;
      this.originalLastname = this.user.lastname;
      this.email = this.user.email;
      this.originalEmail = this.user.email;
      this.description = this.user.description;
      this.originalDescription = this.user.description;
      this.nickname = this.user.nickname;
      this.originalNickname = this.user.nickname;
      this.mobile = this.user.mobile;
      this.originalMobile = this.user.mobile;
    }
    // console.log('created awaited');
  },
  methods: {
    resetForm() {
      this.error = false;
      this.errorMessage = 'Error.';
      this.emailError = null;
      this.conflictEmail = null;
      this.firstname = this.originalFirstname;
      this.lastname = this.originalLastname;
      this.nickname = this.originalNickname;
      this.email = this.originalEmail;
      this.description = this.originalDescription;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.error = false;
        this.loading = true;
        this.emailError = null;
        this.conflictEmail = null;
        const response = await this.updateProfile({
          userId: this.user._id,
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          description: this.description,
          nickname: this.nickname || '',
          mobile: this.mobile || ''
        });
        this.loading = false;
        if (response && response.error) {
          // eslint-disable-next-line
          // console.log('response', response)
          if (response.statusCode === 409) {
            this.conflictEmail = this.email;
            this.emailError =
              'Error! This email address is already assigned to another Groupmail account. Please choose a different address';
          } else if (response.statusCode === 401) {
            this.errorMessage = `Error! Apparently your token has expired (code: ${response.statusCode})`;
            this.error = true;
          } else {
            this.errorMessage = `Error! ${response.message} (code ${response.statusCode})`;
            this.error = true;
          }
        } else {
          this.setSnack('You have successfully updated your profile.');
          this.originalFirstname = this.firstname;
          this.originalLastname = this.lastname;
          this.originalNickname = this.nickname || '';
          this.originalEmail = this.email;
          this.originalDescription = this.description;
          this.originalMobile = this.mobile;
          if (this.user) this.avatar = this.user.avatar;
        }
      }
    },
    async verifyEmail() {
      await this.sendVerification({
        userId: this.user._id
      });
      this.setSnack('Verifications instructions sent to your email');
    },
    ...mapActions({
      sendVerification: 'account/sendVerificationEmail',
      updateProfile: 'account/updateProfile',
      setSnack: 'snackbar/setSnack'
    })
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isDirty && this.user) {
      const res = await this.$dialog.warning({
        text:
          'You have un-saved changes. Do you really want to exit without saving first?',
        title: 'Discard Un-saved changes?',
        actions: {
          false: {
            text: 'No',
            color: 'primary'
          },
          true: {
            text: 'Yes',
            color: 'red'
          }
        }
      });
      if (res) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
